/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
};

export type Address = {
  __typename?: "Address";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  geocoding?: Maybe<Scalars["JSON"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
  zip?: Maybe<Scalars["String"]["output"]>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  geocoding?: InputMaybe<Scalars["JSON"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  street?: InputMaybe<Scalars["String"]["input"]>;
  zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type AgeGroup = {
  __typename?: "AgeGroup";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** League Description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** whether invitation scheduling is enabled for this age group */
  inviteSchedulingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Determines if rosters are locked for this age group */
  lockRoster?: Maybe<Scalars["Boolean"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Age group name */
  name: Scalars["String"]["output"];
  /** Whether open scheduling is enabled for this age group */
  openSchedulingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** SKU for determining the related purchasable product */
  registrationProduct?: Maybe<Scalars["String"]["output"]>;
  registrations?: Maybe<Array<Registration>>;
  /** Controls whether scheduling is open for this age group */
  schedulingOpen?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  season: Season;
  /** sort order for a list of levels */
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  team_levels?: Maybe<Array<TeamLevel>>;
};

export type AgeGroupRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type AgeGroupTeam_LevelsArgs = {
  filter?: InputMaybe<QueryTeamLevelInput>;
};

/** Messages List */
export type Announcement = {
  __typename?: "Announcement";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** The body of the message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** The body of the message */
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  /** The title of the announcement */
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Attendance = {
  __typename?: "Attendance";
  /** Whether the player attended the game */
  attended?: Maybe<Scalars["Boolean"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  game: Game;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Whether the player plans to attend the game */
  planning_to_attend?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  registration: Registration;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  roster: RosterEntry;
};

export type AuthZDirectiveCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
  not?: InputMaybe<AuthZRules>;
  or?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
};

export type AuthZDirectiveDeepCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
  id?: InputMaybe<AuthZRules>;
  not?: InputMaybe<AuthZDirectiveDeepCompositeRulesInput>;
  or?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
};

export enum AuthZRules {
  IsAdmin = "IsAdmin",
  IsAuthenticated = "IsAuthenticated",
  IsCoach = "IsCoach",
  IsLeagueAdmin = "IsLeagueAdmin",
  IsManager = "IsManager",
  IsScoreKeeper = "IsScoreKeeper",
  IsTeamAdmin = "IsTeamAdmin",
  IsUser = "IsUser",
  IsUserOwner = "IsUserOwner",
}

export type BooleanQueryFilter = {
  eq?: InputMaybe<Scalars["Boolean"]["input"]>;
  gt?: InputMaybe<Scalars["Boolean"]["input"]>;
  gte?: InputMaybe<Scalars["Boolean"]["input"]>;
  in?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  like?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["Boolean"]["input"]>;
  lte?: InputMaybe<Scalars["Boolean"]["input"]>;
  ne?: InputMaybe<Scalars["Boolean"]["input"]>;
  not?: InputMaybe<Scalars["Boolean"]["input"]>;
  regex?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Carousel = {
  __typename?: "Carousel";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  image?: Maybe<FileMeta>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  link?: Maybe<Scalars["String"]["output"]>;
  linktext?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CreateAgeGroupInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** whether invitation scheduling is enabled for this age group */
  inviteSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Determines if rosters are locked for this age group */
  lockRoster?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Age group name */
  name: Scalars["String"]["input"];
  /** Whether open scheduling is enabled for this age group */
  openSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SKU for determining the related purchasable product */
  registrationProduct?: InputMaybe<Scalars["String"]["input"]>;
  /** Controls whether scheduling is open for this age group */
  schedulingOpen?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateAnnouncementInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** The body of the message */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The body of the message */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  /** The title of the announcement */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateAttendanceInput = {
  /** Whether the player attended the game */
  attended?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  game?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Whether the player plans to attend the game */
  planning_to_attend?: InputMaybe<Scalars["Boolean"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  roster?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateCarouselInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  linktext?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateDivisionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name: Scalars["String"]["input"];
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateEmailLogInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  messageId?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  response?: InputMaybe<Scalars["JSON"]["input"]>;
  responseCode?: InputMaybe<Scalars["String"]["input"]>;
  rosterId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateFacilityInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  fieldDescription?: InputMaybe<Scalars["String"]["input"]>;
  fieldName?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name: Scalars["String"]["input"];
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateFileMetaInput = {
  container?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateGameDateTimeInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  datetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  taken?: InputMaybe<Scalars["Boolean"]["input"]>;
  time?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateGameInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator if the away team forfeited */
  awayTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * A value used to inform the home team that the away team has offered
   * to use their facility to host the game
   */
  awayTeamOffersToHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the away team */
  awayTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  away_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator to show the date is confirmed */
  confirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the confirmation happened */
  confirmedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** Property to explicity exclude a match from standing calculations. */
  excludeFromStandings?: InputMaybe<Scalars["Boolean"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of match */
  gameType?: InputMaybe<Scalars["String"]["input"]>;
  /** If this game appears in a sequence, the order number in that sequence */
  game_number?: InputMaybe<Scalars["Float"]["input"]>;
  /** Indicator if the home team forfeited */
  homeTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the home team */
  homeTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  home_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has an outcome */
  isPlayed: Scalars["Boolean"]["input"];
  /** Virtual field to determine if the game has a tied outcome */
  isTied: Scalars["Boolean"]["input"];
  /** Should not be used */
  isTournamentMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  losing_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  losing_team_id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Tracker to see if an official was assigned */
  officialAssigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A message to indicate why the game is postponed */
  postponeReason?: InputMaybe<Scalars["String"]["input"]>;
  /** A flag to indicate tha game is postponed */
  postponed?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  winning_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  winning_team_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateLeagueInput = {
  /** League Acronym */
  acronym?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for age group directors */
  adgRole?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for admins */
  adminRole?: InputMaybe<Scalars["String"]["input"]>;
  /** A tagline to display for a league */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /** League Primary Color */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** A list of domains */
  domains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Url for this league */
  leagueUrl?: InputMaybe<Scalars["String"]["input"]>;
  leaguesettings?: InputMaybe<LeagueSettingInput>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name: Scalars["String"]["input"];
  /** A legacy value for determining which league is by a url part */
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateLeagueRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateLeagueWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRegistrationInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** The preferred division preference */
  divisionPreference?: InputMaybe<Scalars["String"]["input"]>;
  /** Elite justification */
  eliteJustification?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** League last year response */
  leagueLastYear?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  standings?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the waiver is signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the waiver was signed */
  waiver_date?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CreateRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRoleMappingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  principalId: Scalars["String"]["input"];
  principalType?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRosterEntryInput = {
  /** Is this player an all star nominee */
  allstarNomination?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Emergency contact information for the player */
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  membershipId?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The player number */
  number?: InputMaybe<Scalars["Float"]["input"]>;
  offSeasonPlayer?: InputMaybe<Scalars["String"]["input"]>;
  player?: InputMaybe<PlayerInput>;
  /** The player position */
  position?: InputMaybe<Scalars["String"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this roster spot waiver has been signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date this waiver was signed */
  waiverdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The waiver signer */
  waiversignature?: InputMaybe<Scalars["String"]["input"]>;
  yearsOfExperience?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateSeasonInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Acronym */
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name: Scalars["String"]["input"];
  /** The date where the registration closes */
  registrationClose?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The date where the registration opens */
  registrationOpen?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CreateSiteSettingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The property key */
  key: Scalars["String"]["input"];
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The base module grouping of the setting */
  module: Scalars["String"]["input"];
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** The property value */
  value: Scalars["String"]["input"];
};

export type CreateSnsMessageInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  message_type?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  subscription_arn?: InputMaybe<Scalars["String"]["input"]>;
  topic_arn?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSponsorInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateStandingsInput = {
  away_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  away_losses?: InputMaybe<Scalars["Float"]["input"]>;
  away_wins?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  games_back?: InputMaybe<Scalars["Float"]["input"]>;
  games_played?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head_two_only?: InputMaybe<Scalars["Float"]["input"]>;
  home_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  home_losses?: InputMaybe<Scalars["Float"]["input"]>;
  home_wins?: InputMaybe<Scalars["Float"]["input"]>;
  losses?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  opponents_opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  points?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed_average?: InputMaybe<Scalars["Float"]["input"]>;
  points_for?: InputMaybe<Scalars["Float"]["input"]>;
  points_for_average?: InputMaybe<Scalars["Float"]["input"]>;
  power_ranking?: InputMaybe<Scalars["Float"]["input"]>;
  ratings_percentage_index?: InputMaybe<Scalars["Float"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  ties?: InputMaybe<Scalars["Float"]["input"]>;
  weighted_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  win_loss_percent?: InputMaybe<Scalars["Float"]["input"]>;
  wins?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateTeamInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  manager?: InputMaybe<Scalars["String"]["input"]>;
  membershipExpiration?: InputMaybe<Scalars["DateTime"]["input"]>;
  membershipLevel?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateTeamLevelInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name: Scalars["String"]["input"];
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateTeamPositionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  positionType?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateUserInput = {
  birthdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  birthdateValidated?: InputMaybe<Scalars["Boolean"]["input"]>;
  cellPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email: Scalars["String"]["input"];
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  homePhone?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  stripeId?: InputMaybe<Scalars["String"]["input"]>;
  userPhotoId?: InputMaybe<Scalars["String"]["input"]>;
  username: Scalars["String"]["input"];
};

export type CreateVanityUrlInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  domain: Scalars["String"]["input"];
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  type: VanityUrlTypeInput;
};

export type CreateWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateWaiverSignatureInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  signature_date?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type DateQueryFilter = {
  eq?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  like?: InputMaybe<Scalars["DateTime"]["input"]>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  ne?: InputMaybe<Scalars["DateTime"]["input"]>;
  not?: InputMaybe<Scalars["DateTime"]["input"]>;
  regex?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Division = {
  __typename?: "Division";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Team Level Name */
  name: Scalars["String"]["output"];
  registrations?: Maybe<Array<Registration>>;
  /** sort order for a list of levels */
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team_level: TeamLevel;
};

export type DivisionRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type EmailLog = {
  __typename?: "EmailLog";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  message?: Maybe<Scalars["JSON"]["output"]>;
  messageId?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  response?: Maybe<Scalars["JSON"]["output"]>;
  responseCode?: Maybe<Scalars["String"]["output"]>;
  rosterId?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type EmergencyContact = {
  __typename?: "EmergencyContact";
  cellPhone?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  relationToPlayer?: Maybe<Scalars["String"]["output"]>;
};

export type EmergencyContactInput = {
  cellPhone?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  relationToPlayer?: InputMaybe<Scalars["String"]["input"]>;
};

export type Facility = {
  __typename?: "Facility";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  fieldDescription?: Maybe<Scalars["String"]["output"]>;
  fieldName?: Maybe<Scalars["String"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  location?: Maybe<Address>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  name: Scalars["String"]["output"];
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team: Team;
};

/** Primary League Object */
export type FileMeta = {
  __typename?: "FileMeta";
  container?: Maybe<Scalars["String"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type Game = {
  __typename?: "Game";
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  age_group?: Maybe<AgeGroup>;
  attendance_records?: Maybe<Array<Attendance>>;
  /** Indicator if the away team forfeited */
  awayTeamForfeit?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * A value used to inform the home team that the away team has offered
   * to use their facility to host the game
   */
  awayTeamOffersToHost?: Maybe<Scalars["Boolean"]["output"]>;
  /** Score for the away team */
  awayTeamScore?: Maybe<Scalars["Float"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  away_team?: Maybe<Registration>;
  /** Indicator to show the date is confirmed */
  confirmed?: Maybe<Scalars["Boolean"]["output"]>;
  /** The date the confirmation happened */
  confirmedDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  date?: Maybe<GameDateTime>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  division?: Maybe<Division>;
  /** Property to explicity exclude a match from standing calculations. */
  excludeFromStandings?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  facility?: Maybe<Facility>;
  /** The type of match */
  gameType?: Maybe<Scalars["String"]["output"]>;
  /** If this game appears in a sequence, the order number in that sequence */
  game_number?: Maybe<Scalars["Float"]["output"]>;
  /** Indicator if the home team forfeited */
  homeTeamForfeit?: Maybe<Scalars["Boolean"]["output"]>;
  /** Score for the home team */
  homeTeamScore?: Maybe<Scalars["Float"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  home_team?: Maybe<Registration>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Virtual field to determine if the game has an outcome */
  isPlayed: Scalars["Boolean"]["output"];
  /** Virtual field to determine if the game has a tied outcome */
  isTied: Scalars["Boolean"]["output"];
  /** Should not be used */
  isTournamentMatch?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  losing_team?: Maybe<Registration>;
  /** Virtual field to determine if the game has a tied outcome */
  losing_team_id?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Tracker to see if an official was assigned */
  officialAssigned?: Maybe<Scalars["Boolean"]["output"]>;
  /** A message to indicate why the game is postponed */
  postponeReason?: Maybe<Scalars["String"]["output"]>;
  /** A flag to indicate tha game is postponed */
  postponed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  season?: Maybe<Season>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team_level?: Maybe<TeamLevel>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  winning_team?: Maybe<Registration>;
  /** Virtual field to determine if the game has a tied outcome */
  winning_team_id?: Maybe<Scalars["String"]["output"]>;
};

export type GameAttendance_RecordsArgs = {
  filter?: InputMaybe<QueryAttendanceInput>;
};

export type GameDateTime = {
  __typename?: "GameDateTime";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  date?: Maybe<Scalars["String"]["output"]>;
  datetime?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  facility?: Maybe<Facility>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  registration?: Maybe<Registration>;
  taken?: Maybe<Scalars["Boolean"]["output"]>;
  time?: Maybe<Scalars["String"]["output"]>;
};

export type League = {
  __typename?: "League";
  /** League Acronym */
  acronym?: Maybe<Scalars["String"]["output"]>;
  /** Role name for age group directors */
  adgRole?: Maybe<Scalars["String"]["output"]>;
  /** Role name for admins */
  adminRole?: Maybe<Scalars["String"]["output"]>;
  announcements?: Maybe<Array<Announcement>>;
  /** A tagline to display for a league */
  caption?: Maybe<Scalars["String"]["output"]>;
  carousels?: Maybe<Array<Carousel>>;
  /**
   * League Primary Color
   * @deprecated deprecated
   */
  color?: Maybe<Scalars["String"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** League Description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** A list of domains */
  domains?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Url for this league */
  leagueUrl?: Maybe<Scalars["String"]["output"]>;
  leaguesettings?: Maybe<LeagueSetting>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  logo?: Maybe<FileMeta>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** League Name */
  name: Scalars["String"]["output"];
  registrations?: Maybe<Array<Registration>>;
  roles?: Maybe<Array<LeagueRole>>;
  seasons?: Maybe<Array<Season>>;
  settings?: Maybe<Array<SiteSetting>>;
  sponsors?: Maybe<Array<Sponsor>>;
  /** A legacy value for determining which league is by a url part */
  urlKey?: Maybe<Scalars["String"]["output"]>;
  waivers?: Maybe<Array<LeagueWaiver>>;
};

export type LeagueAnnouncementsArgs = {
  filter?: InputMaybe<QueryAnnouncementInput>;
};

export type LeagueCarouselsArgs = {
  filter?: InputMaybe<QueryCarouselInput>;
};

export type LeagueRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type LeagueRolesArgs = {
  filter?: InputMaybe<QueryLeagueRoleInput>;
};

export type LeagueSeasonsArgs = {
  filter?: InputMaybe<QuerySeasonInput>;
};

export type LeagueSettingsArgs = {
  filter?: InputMaybe<QuerySiteSettingInput>;
};

export type LeagueSponsorsArgs = {
  filter?: InputMaybe<QuerySponsorInput>;
};

export type LeagueWaiversArgs = {
  filter?: InputMaybe<QueryLeagueWaiverInput>;
};

/** Primary League Object */
export type LeagueRole = {
  __typename?: "LeagueRole";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  role?: Maybe<Role>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  user?: Maybe<User>;
};

export type LeagueSetting = {
  __typename?: "LeagueSetting";
  disableAwayTeamReschedule?: Maybe<Scalars["Boolean"]["output"]>;
  disableRegistration?: Maybe<Scalars["Boolean"]["output"]>;
  divisionPreferences?: Maybe<Array<Scalars["String"]["output"]>>;
  enableAdvancedExport?: Maybe<Scalars["Boolean"]["output"]>;
  enableAllStar?: Maybe<Scalars["Boolean"]["output"]>;
  enableDivisionPreference?: Maybe<Scalars["Boolean"]["output"]>;
  enableOfferToHost?: Maybe<Scalars["Boolean"]["output"]>;
  enableOpenGameDeletion?: Maybe<Scalars["Boolean"]["output"]>;
  enableRosterMembershipId?: Maybe<Scalars["Boolean"]["output"]>;
  enableRoundRobin?: Maybe<Scalars["Boolean"]["output"]>;
  enabledEmergencyContacts?: Maybe<Scalars["Boolean"]["output"]>;
  fieldDescriptionHelp?: Maybe<Scalars["String"]["output"]>;
  fieldDescriptionTitle?: Maybe<Scalars["String"]["output"]>;
  helpContent?: Maybe<Scalars["String"]["output"]>;
  hideElite?: Maybe<Scalars["Boolean"]["output"]>;
  hideHomeDates?: Maybe<Scalars["Boolean"]["output"]>;
  hideLastYearRegistration?: Maybe<Scalars["Boolean"]["output"]>;
  hideOutOfDivisionInformation?: Maybe<Scalars["Boolean"]["output"]>;
  hideRosters?: Maybe<Scalars["Boolean"]["output"]>;
  hideSchedule?: Maybe<Scalars["Boolean"]["output"]>;
  hideTournament?: Maybe<Scalars["Boolean"]["output"]>;
  lockRoster?: Maybe<Scalars["Boolean"]["output"]>;
  minimumHomeDates?: Maybe<Scalars["Float"]["output"]>;
  minimumRoster?: Maybe<Scalars["Float"]["output"]>;
  openSchedulingMode?: Maybe<Scalars["Boolean"]["output"]>;
  registrationForm?: Maybe<Scalars["String"]["output"]>;
  registrationInstructions?: Maybe<Scalars["String"]["output"]>;
  registrationLegal?: Maybe<Scalars["String"]["output"]>;
  registrationPayments?: Maybe<Scalars["Boolean"]["output"]>;
  requireRegistrationWaiver?: Maybe<Scalars["Boolean"]["output"]>;
  restrictScheduling?: Maybe<Scalars["Boolean"]["output"]>;
  rosterGrade?: Maybe<Scalars["Boolean"]["output"]>;
  rosterMemberIdLabel?: Maybe<Scalars["String"]["output"]>;
  showOfficialsArea?: Maybe<Scalars["Boolean"]["output"]>;
  showRegistrationForm?: Maybe<Scalars["Boolean"]["output"]>;
  tournamentName?: Maybe<Scalars["String"]["output"]>;
  waiverText?: Maybe<Scalars["String"]["output"]>;
};

export type LeagueSettingInput = {
  disableAwayTeamReschedule?: InputMaybe<Scalars["Boolean"]["input"]>;
  disableRegistration?: InputMaybe<Scalars["Boolean"]["input"]>;
  divisionPreferences?: InputMaybe<Array<Scalars["String"]["input"]>>;
  enableAdvancedExport?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableAllStar?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableDivisionPreference?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableOfferToHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableOpenGameDeletion?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableRosterMembershipId?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableRoundRobin?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabledEmergencyContacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  fieldDescriptionHelp?: InputMaybe<Scalars["String"]["input"]>;
  fieldDescriptionTitle?: InputMaybe<Scalars["String"]["input"]>;
  helpContent?: InputMaybe<Scalars["String"]["input"]>;
  hideElite?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideHomeDates?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideLastYearRegistration?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideOutOfDivisionInformation?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideRosters?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideSchedule?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideTournament?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockRoster?: InputMaybe<Scalars["Boolean"]["input"]>;
  minimumHomeDates?: InputMaybe<Scalars["Float"]["input"]>;
  minimumRoster?: InputMaybe<Scalars["Float"]["input"]>;
  openSchedulingMode?: InputMaybe<Scalars["Boolean"]["input"]>;
  registrationForm?: InputMaybe<Scalars["String"]["input"]>;
  registrationInstructions?: InputMaybe<Scalars["String"]["input"]>;
  registrationLegal?: InputMaybe<Scalars["String"]["input"]>;
  registrationPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  requireRegistrationWaiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  restrictScheduling?: InputMaybe<Scalars["Boolean"]["input"]>;
  rosterGrade?: InputMaybe<Scalars["Boolean"]["input"]>;
  rosterMemberIdLabel?: InputMaybe<Scalars["String"]["input"]>;
  showOfficialsArea?: InputMaybe<Scalars["Boolean"]["input"]>;
  showRegistrationForm?: InputMaybe<Scalars["Boolean"]["input"]>;
  tournamentName?: InputMaybe<Scalars["String"]["input"]>;
  waiverText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Primary League Object */
export type LeagueWaiver = {
  __typename?: "LeagueWaiver";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  waiver?: Maybe<Waiver>;
};

export type Mutation = {
  __typename?: "Mutation";
  add_age_group_to_season: AgeGroup;
  add_announcement_to_league: Announcement;
  add_attendance_to_game: Attendance;
  add_carousel_to_league: Carousel;
  add_division_to_team_level: Division;
  add_facility_to_team: Facility;
  add_game_date_time_to_registration: GameDateTime;
  add_game_to_registration: Game;
  add_game_to_team_level: Game;
  add_league_role_to_league: LeagueRole;
  add_league_role_to_user: LeagueRole;
  add_league_waiver_to_league: LeagueWaiver;
  add_registration_to_age_group: Registration;
  add_registration_to_division: Registration;
  add_registration_to_league: Registration;
  add_registration_to_season: Registration;
  add_registration_to_team: Registration;
  add_registration_to_team_level: Registration;
  add_role_mapping_to_role: RoleMapping;
  add_role_mapping_to_user: RoleMapping;
  add_roster_entry_to_registration: RosterEntry;
  add_season_to_league: Season;
  add_site_setting_to_league: SiteSetting;
  add_site_setting_to_season: SiteSetting;
  add_sponsor_to_league: Sponsor;
  add_team_level_to_age_group: TeamLevel;
  add_team_position_to_team: TeamPosition;
  add_team_position_to_user: TeamPosition;
  add_team_to_user: Team;
  add_waiver_signature_to_user: WaiverSignature;
  create_age_group: AgeGroup;
  create_announcement: Announcement;
  create_attendance: Attendance;
  create_carousel: Carousel;
  create_division: Division;
  create_email_log: EmailLog;
  create_facility: Facility;
  create_file_meta: FileMeta;
  create_game: Game;
  create_game_date_time: GameDateTime;
  create_league: League;
  create_league_role: LeagueRole;
  create_league_waiver: LeagueWaiver;
  create_registration: Registration;
  create_role: Role;
  create_role_mapping: RoleMapping;
  create_roster_entry: RosterEntry;
  create_season: Season;
  create_season_registration?: Maybe<Registration>;
  create_site_setting: SiteSetting;
  create_sns_message: SnsMessage;
  create_sponsor: Sponsor;
  create_standings: Standings;
  create_team: Team;
  create_team_level: TeamLevel;
  create_team_position: TeamPosition;
  create_user: User;
  create_vanity_url: VanityUrl;
  create_waiver: Waiver;
  create_waiver_signature: WaiverSignature;
  remove_age_group: AgeGroup;
  remove_age_group_from_season: AgeGroup;
  remove_announcement: Announcement;
  remove_announcement_from_league: Announcement;
  remove_attendance: Attendance;
  remove_attendance_from_game: Attendance;
  remove_carousel: Carousel;
  remove_carousel_from_league: Carousel;
  remove_division: Division;
  remove_division_from_team_level: Division;
  remove_email_log: EmailLog;
  remove_facility: Facility;
  remove_facility_from_team: Facility;
  remove_file_meta: FileMeta;
  remove_game: Game;
  remove_game_date_time: GameDateTime;
  remove_game_date_time_from_registration: GameDateTime;
  remove_game_from_registration: Game;
  remove_game_from_team_level: Game;
  remove_league: League;
  remove_league_role: LeagueRole;
  remove_league_role_from_league: LeagueRole;
  remove_league_role_from_user: LeagueRole;
  remove_league_waiver: LeagueWaiver;
  remove_league_waiver_from_league: LeagueWaiver;
  remove_registration: Registration;
  remove_registration_from_age_group: Registration;
  remove_registration_from_division: Registration;
  remove_registration_from_league: Registration;
  remove_registration_from_season: Registration;
  remove_registration_from_team: Registration;
  remove_registration_from_team_level: Registration;
  remove_role: Role;
  remove_role_mapping: RoleMapping;
  remove_role_mapping_from_role: RoleMapping;
  remove_role_mapping_from_user: RoleMapping;
  remove_roster_entry: RosterEntry;
  remove_roster_entry_from_registration: RosterEntry;
  remove_season: Season;
  remove_season_from_league: Season;
  remove_site_setting: SiteSetting;
  remove_site_setting_from_league: SiteSetting;
  remove_site_setting_from_season: SiteSetting;
  remove_sns_message: SnsMessage;
  remove_sponsor: Sponsor;
  remove_sponsor_from_league: Sponsor;
  remove_standings: Standings;
  remove_team: Team;
  remove_team_from_user: Team;
  remove_team_level: TeamLevel;
  remove_team_level_from_age_group: TeamLevel;
  remove_team_position: TeamPosition;
  remove_team_position_from_team: TeamPosition;
  remove_team_position_from_user: TeamPosition;
  remove_user: User;
  remove_vanity_url: VanityUrl;
  remove_waiver: Waiver;
  remove_waiver_signature: WaiverSignature;
  remove_waiver_signature_from_user: WaiverSignature;
  sign_waiver?: Maybe<RosterEntry>;
  update_age_group: AgeGroup;
  update_announcement: Announcement;
  update_attendance: Attendance;
  update_carousel: Carousel;
  update_division: Division;
  update_email_log: EmailLog;
  update_facility: Facility;
  update_file_meta: FileMeta;
  update_game: Game;
  update_game_date_time: GameDateTime;
  update_league: League;
  update_league_role: LeagueRole;
  update_league_waiver: LeagueWaiver;
  update_many_age_group: Array<AgeGroup>;
  update_many_announcement: Array<Announcement>;
  update_many_attendance: Array<Attendance>;
  update_many_carousel: Array<Carousel>;
  update_many_division: Array<Division>;
  update_many_email_log: Array<EmailLog>;
  update_many_facility: Array<Facility>;
  update_many_file_meta: Array<FileMeta>;
  update_many_game: Array<Game>;
  update_many_game_date_time: Array<GameDateTime>;
  update_many_league: Array<League>;
  update_many_league_role: Array<LeagueRole>;
  update_many_league_waiver: Array<LeagueWaiver>;
  update_many_registration: Array<Registration>;
  update_many_role: Array<Role>;
  update_many_role_mapping: Array<RoleMapping>;
  update_many_roster_entry: Array<RosterEntry>;
  update_many_season: Array<Season>;
  update_many_site_setting: Array<SiteSetting>;
  update_many_sns_message: Array<SnsMessage>;
  update_many_sponsor: Array<Sponsor>;
  update_many_standings: Array<Standings>;
  update_many_team: Array<Team>;
  update_many_team_level: Array<TeamLevel>;
  update_many_team_position: Array<TeamPosition>;
  update_many_user: Array<User>;
  update_many_vanity_url: Array<VanityUrl>;
  update_many_waiver: Array<Waiver>;
  update_many_waiver_signature: Array<WaiverSignature>;
  update_registration: Registration;
  update_role: Role;
  update_role_mapping: RoleMapping;
  update_roster_entry: RosterEntry;
  update_season: Season;
  update_site_setting: SiteSetting;
  update_sns_message: SnsMessage;
  update_sponsor: Sponsor;
  update_standings: Standings;
  update_team: Team;
  update_team_level: TeamLevel;
  update_team_position: TeamPosition;
  update_user: User;
  update_vanity_url: VanityUrl;
  update_waiver: Waiver;
  update_waiver_signature: WaiverSignature;
  upsert_age_group: AgeGroup;
  upsert_age_group_to_season: AgeGroup;
  upsert_announcement: Announcement;
  upsert_announcement_to_league: Announcement;
  upsert_attendance: Attendance;
  upsert_attendance_to_game: Attendance;
  upsert_carousel: Carousel;
  upsert_carousel_to_league: Carousel;
  upsert_division: Division;
  upsert_division_to_team_level: Division;
  upsert_email_log: EmailLog;
  upsert_facility: Facility;
  upsert_facility_to_team: Facility;
  upsert_file_meta: FileMeta;
  upsert_game: Game;
  upsert_game_date_time: GameDateTime;
  upsert_game_date_time_to_registration: GameDateTime;
  upsert_game_to_registration: Game;
  upsert_game_to_team_level: Game;
  upsert_league: League;
  upsert_league_role: LeagueRole;
  upsert_league_role_to_league: LeagueRole;
  upsert_league_role_to_user: LeagueRole;
  upsert_league_waiver: LeagueWaiver;
  upsert_league_waiver_to_league: LeagueWaiver;
  upsert_many_age_group_to_season: Array<AgeGroup>;
  upsert_many_announcement_to_league: Array<Announcement>;
  upsert_many_attendance_to_game: Array<Attendance>;
  upsert_many_carousel_to_league: Array<Carousel>;
  upsert_many_division_to_team_level: Array<Division>;
  upsert_many_facility_to_team: Array<Facility>;
  upsert_many_game_date_time_to_registration: Array<GameDateTime>;
  upsert_many_game_to_registration: Array<Game>;
  upsert_many_game_to_team_level: Array<Game>;
  upsert_many_league_role_to_league: Array<LeagueRole>;
  upsert_many_league_role_to_user: Array<LeagueRole>;
  upsert_many_league_waiver_to_league: Array<LeagueWaiver>;
  upsert_many_registration_to_age_group: Array<Registration>;
  upsert_many_registration_to_division: Array<Registration>;
  upsert_many_registration_to_league: Array<Registration>;
  upsert_many_registration_to_season: Array<Registration>;
  upsert_many_registration_to_team: Array<Registration>;
  upsert_many_registration_to_team_level: Array<Registration>;
  upsert_many_role_mapping_to_role: Array<RoleMapping>;
  upsert_many_role_mapping_to_user: Array<RoleMapping>;
  upsert_many_roster_entry_to_registration: Array<RosterEntry>;
  upsert_many_season_to_league: Array<Season>;
  upsert_many_site_setting_to_league: Array<SiteSetting>;
  upsert_many_site_setting_to_season: Array<SiteSetting>;
  upsert_many_sponsor_to_league: Array<Sponsor>;
  upsert_many_team_level_to_age_group: Array<TeamLevel>;
  upsert_many_team_position_to_team: Array<TeamPosition>;
  upsert_many_team_position_to_user: Array<TeamPosition>;
  upsert_many_team_to_user: Array<Team>;
  upsert_many_waiver_signature_to_user: Array<WaiverSignature>;
  upsert_registration: Registration;
  upsert_registration_to_age_group: Registration;
  upsert_registration_to_division: Registration;
  upsert_registration_to_league: Registration;
  upsert_registration_to_season: Registration;
  upsert_registration_to_team: Registration;
  upsert_registration_to_team_level: Registration;
  upsert_role: Role;
  upsert_role_mapping: RoleMapping;
  upsert_role_mapping_to_role: RoleMapping;
  upsert_role_mapping_to_user: RoleMapping;
  upsert_roster_entry: RosterEntry;
  upsert_roster_entry_to_registration: RosterEntry;
  upsert_season: Season;
  upsert_season_to_league: Season;
  upsert_site_setting: SiteSetting;
  upsert_site_setting_to_league: SiteSetting;
  upsert_site_setting_to_season: SiteSetting;
  upsert_sns_message: SnsMessage;
  upsert_sponsor: Sponsor;
  upsert_sponsor_to_league: Sponsor;
  upsert_standings: Standings;
  upsert_team: Team;
  upsert_team_level: TeamLevel;
  upsert_team_level_to_age_group: TeamLevel;
  upsert_team_position: TeamPosition;
  upsert_team_position_to_team: TeamPosition;
  upsert_team_position_to_user: TeamPosition;
  upsert_team_to_user: Team;
  upsert_user: User;
  upsert_vanity_url: VanityUrl;
  upsert_waiver: Waiver;
  upsert_waiver_signature: WaiverSignature;
  upsert_waiver_signature_to_user: WaiverSignature;
};

export type MutationAdd_Age_Group_To_SeasonArgs = {
  age_group: CreateAgeGroupInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Announcement_To_LeagueArgs = {
  announcement: CreateAnnouncementInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Attendance_To_GameArgs = {
  attendance: CreateAttendanceInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Carousel_To_LeagueArgs = {
  carousel: CreateCarouselInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Division_To_Team_LevelArgs = {
  division: CreateDivisionInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Facility_To_TeamArgs = {
  facility: CreateFacilityInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Game_Date_Time_To_RegistrationArgs = {
  game_date_time: CreateGameDateTimeInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Game_To_RegistrationArgs = {
  game: CreateGameInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_Game_To_Team_LevelArgs = {
  game: CreateGameInput;
  id: Scalars["String"]["input"];
};

export type MutationAdd_League_Role_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_role: CreateLeagueRoleInput;
};

export type MutationAdd_League_Role_To_UserArgs = {
  id: Scalars["String"]["input"];
  league_role: CreateLeagueRoleInput;
};

export type MutationAdd_League_Waiver_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_waiver: CreateLeagueWaiverInput;
};

export type MutationAdd_Registration_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Registration_To_DivisionArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Registration_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Registration_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Registration_To_TeamArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Registration_To_Team_LevelArgs = {
  id: Scalars["String"]["input"];
  registration: CreateRegistrationInput;
};

export type MutationAdd_Role_Mapping_To_RoleArgs = {
  id: Scalars["String"]["input"];
  role_mapping: CreateRoleMappingInput;
};

export type MutationAdd_Role_Mapping_To_UserArgs = {
  id: Scalars["String"]["input"];
  role_mapping: CreateRoleMappingInput;
};

export type MutationAdd_Roster_Entry_To_RegistrationArgs = {
  id: Scalars["String"]["input"];
  roster_entry: CreateRosterEntryInput;
};

export type MutationAdd_Season_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  season: CreateSeasonInput;
};

export type MutationAdd_Site_Setting_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  site_setting: CreateSiteSettingInput;
};

export type MutationAdd_Site_Setting_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  site_setting: CreateSiteSettingInput;
};

export type MutationAdd_Sponsor_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  sponsor: CreateSponsorInput;
};

export type MutationAdd_Team_Level_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  team_level: CreateTeamLevelInput;
};

export type MutationAdd_Team_Position_To_TeamArgs = {
  id: Scalars["String"]["input"];
  team_position: CreateTeamPositionInput;
};

export type MutationAdd_Team_Position_To_UserArgs = {
  id: Scalars["String"]["input"];
  team_position: CreateTeamPositionInput;
};

export type MutationAdd_Team_To_UserArgs = {
  id: Scalars["String"]["input"];
  team: CreateTeamInput;
};

export type MutationAdd_Waiver_Signature_To_UserArgs = {
  id: Scalars["String"]["input"];
  waiver_signature: CreateWaiverSignatureInput;
};

export type MutationCreate_Age_GroupArgs = {
  createInput: CreateAgeGroupInput;
};

export type MutationCreate_AnnouncementArgs = {
  createInput: CreateAnnouncementInput;
};

export type MutationCreate_AttendanceArgs = {
  createInput: CreateAttendanceInput;
};

export type MutationCreate_CarouselArgs = {
  createInput: CreateCarouselInput;
};

export type MutationCreate_DivisionArgs = {
  createInput: CreateDivisionInput;
};

export type MutationCreate_Email_LogArgs = {
  createInput: CreateEmailLogInput;
};

export type MutationCreate_FacilityArgs = {
  createInput: CreateFacilityInput;
};

export type MutationCreate_File_MetaArgs = {
  createInput: CreateFileMetaInput;
};

export type MutationCreate_GameArgs = {
  createInput: CreateGameInput;
};

export type MutationCreate_Game_Date_TimeArgs = {
  createInput: CreateGameDateTimeInput;
};

export type MutationCreate_LeagueArgs = {
  createInput: CreateLeagueInput;
};

export type MutationCreate_League_RoleArgs = {
  createInput: CreateLeagueRoleInput;
};

export type MutationCreate_League_WaiverArgs = {
  createInput: CreateLeagueWaiverInput;
};

export type MutationCreate_RegistrationArgs = {
  createInput: CreateRegistrationInput;
};

export type MutationCreate_RoleArgs = {
  createInput: CreateRoleInput;
};

export type MutationCreate_Role_MappingArgs = {
  createInput: CreateRoleMappingInput;
};

export type MutationCreate_Roster_EntryArgs = {
  createInput: CreateRosterEntryInput;
};

export type MutationCreate_SeasonArgs = {
  createInput: CreateSeasonInput;
};

export type MutationCreate_Season_RegistrationArgs = {
  administrator?: InputMaybe<UpsertUserInput>;
  manager: UpsertUserInput;
  registration: CreateRegistrationInput;
  team: UpsertTeamInput;
};

export type MutationCreate_Site_SettingArgs = {
  createInput: CreateSiteSettingInput;
};

export type MutationCreate_Sns_MessageArgs = {
  createInput: CreateSnsMessageInput;
};

export type MutationCreate_SponsorArgs = {
  createInput: CreateSponsorInput;
};

export type MutationCreate_StandingsArgs = {
  createInput: CreateStandingsInput;
};

export type MutationCreate_TeamArgs = {
  createInput: CreateTeamInput;
};

export type MutationCreate_Team_LevelArgs = {
  createInput: CreateTeamLevelInput;
};

export type MutationCreate_Team_PositionArgs = {
  createInput: CreateTeamPositionInput;
};

export type MutationCreate_UserArgs = {
  createInput: CreateUserInput;
};

export type MutationCreate_Vanity_UrlArgs = {
  createInput: CreateVanityUrlInput;
};

export type MutationCreate_WaiverArgs = {
  createInput: CreateWaiverInput;
};

export type MutationCreate_Waiver_SignatureArgs = {
  createInput: CreateWaiverSignatureInput;
};

export type MutationRemove_Age_GroupArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Age_Group_From_SeasonArgs = {
  age_group: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_AnnouncementArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Announcement_From_LeagueArgs = {
  announcement: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_AttendanceArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Attendance_From_GameArgs = {
  attendance: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_CarouselArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Carousel_From_LeagueArgs = {
  carousel: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_DivisionArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Division_From_Team_LevelArgs = {
  division: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_Email_LogArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_FacilityArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Facility_From_TeamArgs = {
  facility: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_File_MetaArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_GameArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Game_Date_TimeArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Game_Date_Time_From_RegistrationArgs = {
  game_date_time: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_Game_From_RegistrationArgs = {
  game: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_Game_From_Team_LevelArgs = {
  game: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRemove_LeagueArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_League_RoleArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_League_Role_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_role: Scalars["String"]["input"];
};

export type MutationRemove_League_Role_From_UserArgs = {
  id: Scalars["String"]["input"];
  league_role: Scalars["String"]["input"];
};

export type MutationRemove_League_WaiverArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_League_Waiver_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_waiver: Scalars["String"]["input"];
};

export type MutationRemove_RegistrationArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_DivisionArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_SeasonArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_TeamArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_Registration_From_Team_LevelArgs = {
  id: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
};

export type MutationRemove_RoleArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Role_MappingArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Role_Mapping_From_RoleArgs = {
  id: Scalars["String"]["input"];
  role_mapping: Scalars["String"]["input"];
};

export type MutationRemove_Role_Mapping_From_UserArgs = {
  id: Scalars["String"]["input"];
  role_mapping: Scalars["String"]["input"];
};

export type MutationRemove_Roster_EntryArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Roster_Entry_From_RegistrationArgs = {
  id: Scalars["String"]["input"];
  roster_entry: Scalars["String"]["input"];
};

export type MutationRemove_SeasonArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Season_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  season: Scalars["String"]["input"];
};

export type MutationRemove_Site_SettingArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Site_Setting_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  site_setting: Scalars["String"]["input"];
};

export type MutationRemove_Site_Setting_From_SeasonArgs = {
  id: Scalars["String"]["input"];
  site_setting: Scalars["String"]["input"];
};

export type MutationRemove_Sns_MessageArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_SponsorArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Sponsor_From_LeagueArgs = {
  id: Scalars["String"]["input"];
  sponsor: Scalars["String"]["input"];
};

export type MutationRemove_StandingsArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_TeamArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Team_From_UserArgs = {
  id: Scalars["String"]["input"];
  team: Scalars["String"]["input"];
};

export type MutationRemove_Team_LevelArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Team_Level_From_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  team_level: Scalars["String"]["input"];
};

export type MutationRemove_Team_PositionArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Team_Position_From_TeamArgs = {
  id: Scalars["String"]["input"];
  team_position: Scalars["String"]["input"];
};

export type MutationRemove_Team_Position_From_UserArgs = {
  id: Scalars["String"]["input"];
  team_position: Scalars["String"]["input"];
};

export type MutationRemove_UserArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Vanity_UrlArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_WaiverArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Waiver_SignatureArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemove_Waiver_Signature_From_UserArgs = {
  id: Scalars["String"]["input"];
  waiver_signature: Scalars["String"]["input"];
};

export type MutationSign_WaiverArgs = {
  roster: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type MutationUpdate_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  update: UpdateAgeGroupInput;
};

export type MutationUpdate_AnnouncementArgs = {
  id: Scalars["String"]["input"];
  update: UpdateAnnouncementInput;
};

export type MutationUpdate_AttendanceArgs = {
  id: Scalars["String"]["input"];
  update: UpdateAttendanceInput;
};

export type MutationUpdate_CarouselArgs = {
  id: Scalars["String"]["input"];
  update: UpdateCarouselInput;
};

export type MutationUpdate_DivisionArgs = {
  id: Scalars["String"]["input"];
  update: UpdateDivisionInput;
};

export type MutationUpdate_Email_LogArgs = {
  id: Scalars["String"]["input"];
  update: UpdateEmailLogInput;
};

export type MutationUpdate_FacilityArgs = {
  id: Scalars["String"]["input"];
  update: UpdateFacilityInput;
};

export type MutationUpdate_File_MetaArgs = {
  id: Scalars["String"]["input"];
  update: UpdateFileMetaInput;
};

export type MutationUpdate_GameArgs = {
  id: Scalars["String"]["input"];
  update: UpdateGameInput;
};

export type MutationUpdate_Game_Date_TimeArgs = {
  id: Scalars["String"]["input"];
  update: UpdateGameDateTimeInput;
};

export type MutationUpdate_LeagueArgs = {
  id: Scalars["String"]["input"];
  update: UpdateLeagueInput;
};

export type MutationUpdate_League_RoleArgs = {
  id: Scalars["String"]["input"];
  update: UpdateLeagueRoleInput;
};

export type MutationUpdate_League_WaiverArgs = {
  id: Scalars["String"]["input"];
  update: UpdateLeagueWaiverInput;
};

export type MutationUpdate_Many_Age_GroupArgs = {
  update: Array<UpsertAgeGroupInput>;
};

export type MutationUpdate_Many_AnnouncementArgs = {
  update: Array<UpsertAnnouncementInput>;
};

export type MutationUpdate_Many_AttendanceArgs = {
  update: Array<UpsertAttendanceInput>;
};

export type MutationUpdate_Many_CarouselArgs = {
  update: Array<UpsertCarouselInput>;
};

export type MutationUpdate_Many_DivisionArgs = {
  update: Array<UpsertDivisionInput>;
};

export type MutationUpdate_Many_Email_LogArgs = {
  update: Array<UpsertEmailLogInput>;
};

export type MutationUpdate_Many_FacilityArgs = {
  update: Array<UpsertFacilityInput>;
};

export type MutationUpdate_Many_File_MetaArgs = {
  update: Array<UpsertFileMetaInput>;
};

export type MutationUpdate_Many_GameArgs = {
  update: Array<UpsertGameInput>;
};

export type MutationUpdate_Many_Game_Date_TimeArgs = {
  update: Array<UpsertGameDateTimeInput>;
};

export type MutationUpdate_Many_LeagueArgs = {
  update: Array<UpsertLeagueInput>;
};

export type MutationUpdate_Many_League_RoleArgs = {
  update: Array<UpsertLeagueRoleInput>;
};

export type MutationUpdate_Many_League_WaiverArgs = {
  update: Array<UpsertLeagueWaiverInput>;
};

export type MutationUpdate_Many_RegistrationArgs = {
  update: Array<UpsertRegistrationInput>;
};

export type MutationUpdate_Many_RoleArgs = {
  update: Array<UpsertRoleInput>;
};

export type MutationUpdate_Many_Role_MappingArgs = {
  update: Array<UpsertRoleMappingInput>;
};

export type MutationUpdate_Many_Roster_EntryArgs = {
  update: Array<UpsertRosterEntryInput>;
};

export type MutationUpdate_Many_SeasonArgs = {
  update: Array<UpsertSeasonInput>;
};

export type MutationUpdate_Many_Site_SettingArgs = {
  update: Array<UpsertSiteSettingInput>;
};

export type MutationUpdate_Many_Sns_MessageArgs = {
  update: Array<UpsertSnsMessageInput>;
};

export type MutationUpdate_Many_SponsorArgs = {
  update: Array<UpsertSponsorInput>;
};

export type MutationUpdate_Many_StandingsArgs = {
  update: Array<UpsertStandingsInput>;
};

export type MutationUpdate_Many_TeamArgs = {
  update: Array<UpsertTeamInput>;
};

export type MutationUpdate_Many_Team_LevelArgs = {
  update: Array<UpsertTeamLevelInput>;
};

export type MutationUpdate_Many_Team_PositionArgs = {
  update: Array<UpsertTeamPositionInput>;
};

export type MutationUpdate_Many_UserArgs = {
  update: Array<UpsertUserInput>;
};

export type MutationUpdate_Many_Vanity_UrlArgs = {
  update: Array<UpsertVanityUrlInput>;
};

export type MutationUpdate_Many_WaiverArgs = {
  update: Array<UpsertWaiverInput>;
};

export type MutationUpdate_Many_Waiver_SignatureArgs = {
  update: Array<UpsertWaiverSignatureInput>;
};

export type MutationUpdate_RegistrationArgs = {
  id: Scalars["String"]["input"];
  update: UpdateRegistrationInput;
};

export type MutationUpdate_RoleArgs = {
  id: Scalars["String"]["input"];
  update: UpdateRoleInput;
};

export type MutationUpdate_Role_MappingArgs = {
  id: Scalars["String"]["input"];
  update: UpdateRoleMappingInput;
};

export type MutationUpdate_Roster_EntryArgs = {
  id: Scalars["String"]["input"];
  update: UpdateRosterEntryInput;
};

export type MutationUpdate_SeasonArgs = {
  id: Scalars["String"]["input"];
  update: UpdateSeasonInput;
};

export type MutationUpdate_Site_SettingArgs = {
  id: Scalars["String"]["input"];
  update: UpdateSiteSettingInput;
};

export type MutationUpdate_Sns_MessageArgs = {
  id: Scalars["String"]["input"];
  update: UpdateSnsMessageInput;
};

export type MutationUpdate_SponsorArgs = {
  id: Scalars["String"]["input"];
  update: UpdateSponsorInput;
};

export type MutationUpdate_StandingsArgs = {
  id: Scalars["String"]["input"];
  update: UpdateStandingsInput;
};

export type MutationUpdate_TeamArgs = {
  id: Scalars["String"]["input"];
  update: UpdateTeamInput;
};

export type MutationUpdate_Team_LevelArgs = {
  id: Scalars["String"]["input"];
  update: UpdateTeamLevelInput;
};

export type MutationUpdate_Team_PositionArgs = {
  id: Scalars["String"]["input"];
  update: UpdateTeamPositionInput;
};

export type MutationUpdate_UserArgs = {
  id: Scalars["String"]["input"];
  update: UpdateUserInput;
};

export type MutationUpdate_Vanity_UrlArgs = {
  id: Scalars["String"]["input"];
  update: UpdateVanityUrlInput;
};

export type MutationUpdate_WaiverArgs = {
  id: Scalars["String"]["input"];
  update: UpdateWaiverInput;
};

export type MutationUpdate_Waiver_SignatureArgs = {
  id: Scalars["String"]["input"];
  update: UpdateWaiverSignatureInput;
};

export type MutationUpsert_Age_GroupArgs = {
  upsert: UpsertAgeGroupInput;
};

export type MutationUpsert_Age_Group_To_SeasonArgs = {
  age_group: UpsertAgeGroupInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_AnnouncementArgs = {
  upsert: UpsertAnnouncementInput;
};

export type MutationUpsert_Announcement_To_LeagueArgs = {
  announcement: UpsertAnnouncementInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_AttendanceArgs = {
  upsert: UpsertAttendanceInput;
};

export type MutationUpsert_Attendance_To_GameArgs = {
  attendance: UpsertAttendanceInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_CarouselArgs = {
  upsert: UpsertCarouselInput;
};

export type MutationUpsert_Carousel_To_LeagueArgs = {
  carousel: UpsertCarouselInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_DivisionArgs = {
  upsert: UpsertDivisionInput;
};

export type MutationUpsert_Division_To_Team_LevelArgs = {
  division: UpsertDivisionInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Email_LogArgs = {
  upsert: UpsertEmailLogInput;
};

export type MutationUpsert_FacilityArgs = {
  upsert: UpsertFacilityInput;
};

export type MutationUpsert_Facility_To_TeamArgs = {
  facility: UpsertFacilityInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_File_MetaArgs = {
  upsert: UpsertFileMetaInput;
};

export type MutationUpsert_GameArgs = {
  upsert: UpsertGameInput;
};

export type MutationUpsert_Game_Date_TimeArgs = {
  upsert: UpsertGameDateTimeInput;
};

export type MutationUpsert_Game_Date_Time_To_RegistrationArgs = {
  game_date_time: UpsertGameDateTimeInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Game_To_RegistrationArgs = {
  game: UpsertGameInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Game_To_Team_LevelArgs = {
  game: UpsertGameInput;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_LeagueArgs = {
  upsert: UpsertLeagueInput;
};

export type MutationUpsert_League_RoleArgs = {
  upsert: UpsertLeagueRoleInput;
};

export type MutationUpsert_League_Role_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_role: UpsertLeagueRoleInput;
};

export type MutationUpsert_League_Role_To_UserArgs = {
  id: Scalars["String"]["input"];
  league_role: UpsertLeagueRoleInput;
};

export type MutationUpsert_League_WaiverArgs = {
  upsert: UpsertLeagueWaiverInput;
};

export type MutationUpsert_League_Waiver_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_waiver: UpsertLeagueWaiverInput;
};

export type MutationUpsert_Many_Age_Group_To_SeasonArgs = {
  age_group: Array<UpsertAgeGroupInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Announcement_To_LeagueArgs = {
  announcement: Array<UpsertAnnouncementInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Attendance_To_GameArgs = {
  attendance: Array<UpsertAttendanceInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Carousel_To_LeagueArgs = {
  carousel: Array<UpsertCarouselInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Division_To_Team_LevelArgs = {
  division: Array<UpsertDivisionInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Facility_To_TeamArgs = {
  facility: Array<UpsertFacilityInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Game_Date_Time_To_RegistrationArgs = {
  game_date_time: Array<UpsertGameDateTimeInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Game_To_RegistrationArgs = {
  game: Array<UpsertGameInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_Game_To_Team_LevelArgs = {
  game: Array<UpsertGameInput>;
  id: Scalars["String"]["input"];
};

export type MutationUpsert_Many_League_Role_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_role: Array<UpsertLeagueRoleInput>;
};

export type MutationUpsert_Many_League_Role_To_UserArgs = {
  id: Scalars["String"]["input"];
  league_role: Array<UpsertLeagueRoleInput>;
};

export type MutationUpsert_Many_League_Waiver_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  league_waiver: Array<UpsertLeagueWaiverInput>;
};

export type MutationUpsert_Many_Registration_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Registration_To_DivisionArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Registration_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Registration_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Registration_To_TeamArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Registration_To_Team_LevelArgs = {
  id: Scalars["String"]["input"];
  registration: Array<UpsertRegistrationInput>;
};

export type MutationUpsert_Many_Role_Mapping_To_RoleArgs = {
  id: Scalars["String"]["input"];
  role_mapping: Array<UpsertRoleMappingInput>;
};

export type MutationUpsert_Many_Role_Mapping_To_UserArgs = {
  id: Scalars["String"]["input"];
  role_mapping: Array<UpsertRoleMappingInput>;
};

export type MutationUpsert_Many_Roster_Entry_To_RegistrationArgs = {
  id: Scalars["String"]["input"];
  roster_entry: Array<UpsertRosterEntryInput>;
};

export type MutationUpsert_Many_Season_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  season: Array<UpsertSeasonInput>;
};

export type MutationUpsert_Many_Site_Setting_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  site_setting: Array<UpsertSiteSettingInput>;
};

export type MutationUpsert_Many_Site_Setting_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  site_setting: Array<UpsertSiteSettingInput>;
};

export type MutationUpsert_Many_Sponsor_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  sponsor: Array<UpsertSponsorInput>;
};

export type MutationUpsert_Many_Team_Level_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  team_level: Array<UpsertTeamLevelInput>;
};

export type MutationUpsert_Many_Team_Position_To_TeamArgs = {
  id: Scalars["String"]["input"];
  team_position: Array<UpsertTeamPositionInput>;
};

export type MutationUpsert_Many_Team_Position_To_UserArgs = {
  id: Scalars["String"]["input"];
  team_position: Array<UpsertTeamPositionInput>;
};

export type MutationUpsert_Many_Team_To_UserArgs = {
  id: Scalars["String"]["input"];
  team: Array<UpsertTeamInput>;
};

export type MutationUpsert_Many_Waiver_Signature_To_UserArgs = {
  id: Scalars["String"]["input"];
  waiver_signature: Array<UpsertWaiverSignatureInput>;
};

export type MutationUpsert_RegistrationArgs = {
  upsert: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_DivisionArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_TeamArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_Registration_To_Team_LevelArgs = {
  id: Scalars["String"]["input"];
  registration: UpsertRegistrationInput;
};

export type MutationUpsert_RoleArgs = {
  upsert: UpsertRoleInput;
};

export type MutationUpsert_Role_MappingArgs = {
  upsert: UpsertRoleMappingInput;
};

export type MutationUpsert_Role_Mapping_To_RoleArgs = {
  id: Scalars["String"]["input"];
  role_mapping: UpsertRoleMappingInput;
};

export type MutationUpsert_Role_Mapping_To_UserArgs = {
  id: Scalars["String"]["input"];
  role_mapping: UpsertRoleMappingInput;
};

export type MutationUpsert_Roster_EntryArgs = {
  upsert: UpsertRosterEntryInput;
};

export type MutationUpsert_Roster_Entry_To_RegistrationArgs = {
  id: Scalars["String"]["input"];
  roster_entry: UpsertRosterEntryInput;
};

export type MutationUpsert_SeasonArgs = {
  upsert: UpsertSeasonInput;
};

export type MutationUpsert_Season_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  season: UpsertSeasonInput;
};

export type MutationUpsert_Site_SettingArgs = {
  upsert: UpsertSiteSettingInput;
};

export type MutationUpsert_Site_Setting_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  site_setting: UpsertSiteSettingInput;
};

export type MutationUpsert_Site_Setting_To_SeasonArgs = {
  id: Scalars["String"]["input"];
  site_setting: UpsertSiteSettingInput;
};

export type MutationUpsert_Sns_MessageArgs = {
  upsert: UpsertSnsMessageInput;
};

export type MutationUpsert_SponsorArgs = {
  upsert: UpsertSponsorInput;
};

export type MutationUpsert_Sponsor_To_LeagueArgs = {
  id: Scalars["String"]["input"];
  sponsor: UpsertSponsorInput;
};

export type MutationUpsert_StandingsArgs = {
  upsert: UpsertStandingsInput;
};

export type MutationUpsert_TeamArgs = {
  upsert: UpsertTeamInput;
};

export type MutationUpsert_Team_LevelArgs = {
  upsert: UpsertTeamLevelInput;
};

export type MutationUpsert_Team_Level_To_Age_GroupArgs = {
  id: Scalars["String"]["input"];
  team_level: UpsertTeamLevelInput;
};

export type MutationUpsert_Team_PositionArgs = {
  upsert: UpsertTeamPositionInput;
};

export type MutationUpsert_Team_Position_To_TeamArgs = {
  id: Scalars["String"]["input"];
  team_position: UpsertTeamPositionInput;
};

export type MutationUpsert_Team_Position_To_UserArgs = {
  id: Scalars["String"]["input"];
  team_position: UpsertTeamPositionInput;
};

export type MutationUpsert_Team_To_UserArgs = {
  id: Scalars["String"]["input"];
  team: UpsertTeamInput;
};

export type MutationUpsert_UserArgs = {
  upsert: UpsertUserInput;
};

export type MutationUpsert_Vanity_UrlArgs = {
  upsert: UpsertVanityUrlInput;
};

export type MutationUpsert_WaiverArgs = {
  upsert: UpsertWaiverInput;
};

export type MutationUpsert_Waiver_SignatureArgs = {
  upsert: UpsertWaiverSignatureInput;
};

export type MutationUpsert_Waiver_Signature_To_UserArgs = {
  id: Scalars["String"]["input"];
  waiver_signature: UpsertWaiverSignatureInput;
};

export type Player = {
  __typename?: "Player";
  birthday?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  guardian2email?: Maybe<Scalars["String"]["output"]>;
  guardianemail?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  phoneNumber2?: Maybe<Scalars["String"]["output"]>;
  phoneNumber3?: Maybe<Scalars["String"]["output"]>;
  zipCode?: Maybe<Scalars["String"]["output"]>;
};

export type PlayerInput = {
  birthday?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  grade?: InputMaybe<Scalars["String"]["input"]>;
  guardian2email?: InputMaybe<Scalars["String"]["input"]>;
  guardianemail?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber2?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber3?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  age_group: AgeGroup;
  age_groups: Array<AgeGroup>;
  announcement: Announcement;
  announcements: Array<Announcement>;
  attendance: Attendance;
  attendances: Array<Attendance>;
  carousel: Carousel;
  carousels: Array<Carousel>;
  division: Division;
  divisions: Array<Division>;
  email_log: EmailLog;
  email_logs: Array<EmailLog>;
  facilities: Array<Facility>;
  facility: Facility;
  file_meta: FileMeta;
  file_metas: Array<FileMeta>;
  game: Game;
  game_date_time: GameDateTime;
  game_date_times: Array<GameDateTime>;
  games: Array<Game>;
  league: League;
  league_role: LeagueRole;
  league_roles: Array<LeagueRole>;
  league_waiver: LeagueWaiver;
  league_waivers: Array<LeagueWaiver>;
  leagues: Array<League>;
  registration: Registration;
  registrations: Array<Registration>;
  role: Role;
  role_mapping: RoleMapping;
  role_mappings: Array<RoleMapping>;
  roles: Array<Role>;
  roster_entries: Array<RosterEntry>;
  roster_entry: RosterEntry;
  season: Season;
  seasons: Array<Season>;
  site_setting: SiteSetting;
  site_settings: Array<SiteSetting>;
  sns_message: SnsMessage;
  sns_messages: Array<SnsMessage>;
  sponsor: Sponsor;
  sponsors: Array<Sponsor>;
  standings: Standings;
  team: Team;
  team_level: TeamLevel;
  team_levels: Array<TeamLevel>;
  team_position: TeamPosition;
  team_positions: Array<TeamPosition>;
  team_registration?: Maybe<Registration>;
  teams: Array<Team>;
  user: User;
  users: Array<User>;
  vanity_url: VanityUrl;
  vanity_url_resolve?: Maybe<VanityUrl>;
  vanity_urls: Array<VanityUrl>;
  waiver: Waiver;
  waiver_signature: WaiverSignature;
  waiver_signatures: Array<WaiverSignature>;
  waivers: Array<Waiver>;
};

export type QueryAge_GroupArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAge_GroupsArgs = {
  filter?: InputMaybe<QueryAgeGroupInput>;
};

export type QueryAnnouncementArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAnnouncementsArgs = {
  filter?: InputMaybe<QueryAnnouncementInput>;
};

export type QueryAttendanceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAttendancesArgs = {
  filter?: InputMaybe<QueryAttendanceInput>;
};

export type QueryCarouselArgs = {
  id: Scalars["String"]["input"];
};

export type QueryCarouselsArgs = {
  filter?: InputMaybe<QueryCarouselInput>;
};

export type QueryDivisionArgs = {
  id: Scalars["String"]["input"];
};

export type QueryDivisionsArgs = {
  filter?: InputMaybe<QueryDivisionInput>;
};

export type QueryEmail_LogArgs = {
  id: Scalars["String"]["input"];
};

export type QueryEmail_LogsArgs = {
  filter?: InputMaybe<QueryEmailLogInput>;
};

export type QueryFacilitiesArgs = {
  filter?: InputMaybe<QueryFacilityInput>;
};

export type QueryFacilityArgs = {
  id: Scalars["String"]["input"];
};

export type QueryFile_MetaArgs = {
  id: Scalars["String"]["input"];
};

export type QueryFile_MetasArgs = {
  filter?: InputMaybe<QueryFileMetaInput>;
};

export type QueryGameArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGame_Date_TimeArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGame_Date_TimesArgs = {
  filter?: InputMaybe<QueryGameDateTimeInput>;
};

export type QueryGamesArgs = {
  filter?: InputMaybe<QueryGameInput>;
};

export type QueryLeagueArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLeague_RoleArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLeague_RolesArgs = {
  filter?: InputMaybe<QueryLeagueRoleInput>;
};

export type QueryLeague_WaiverArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLeague_WaiversArgs = {
  filter?: InputMaybe<QueryLeagueWaiverInput>;
};

export type QueryLeaguesArgs = {
  filter?: InputMaybe<QueryLeagueInput>;
};

export type QueryRegistrationArgs = {
  id: Scalars["String"]["input"];
};

export type QueryRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type QueryRoleArgs = {
  id: Scalars["String"]["input"];
};

export type QueryRole_MappingArgs = {
  id: Scalars["String"]["input"];
};

export type QueryRole_MappingsArgs = {
  filter?: InputMaybe<QueryRoleMappingInput>;
};

export type QueryRolesArgs = {
  filter?: InputMaybe<QueryRoleInput>;
};

export type QueryRoster_EntriesArgs = {
  filter?: InputMaybe<QueryRosterEntryInput>;
};

export type QueryRoster_EntryArgs = {
  id: Scalars["String"]["input"];
};

export type QuerySeasonArgs = {
  id: Scalars["String"]["input"];
};

export type QuerySeasonsArgs = {
  filter?: InputMaybe<QuerySeasonInput>;
};

export type QuerySite_SettingArgs = {
  id: Scalars["String"]["input"];
};

export type QuerySite_SettingsArgs = {
  filter?: InputMaybe<QuerySiteSettingInput>;
};

export type QuerySns_MessageArgs = {
  id: Scalars["String"]["input"];
};

export type QuerySns_MessagesArgs = {
  filter?: InputMaybe<QuerySnsMessageInput>;
};

export type QuerySponsorArgs = {
  id: Scalars["String"]["input"];
};

export type QuerySponsorsArgs = {
  filter?: InputMaybe<QuerySponsorInput>;
};

export type QueryStandingsArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTeamArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTeam_LevelArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTeam_LevelsArgs = {
  filter?: InputMaybe<QueryTeamLevelInput>;
};

export type QueryTeam_PositionArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTeam_PositionsArgs = {
  filter?: InputMaybe<QueryTeamPositionInput>;
};

export type QueryTeam_RegistrationArgs = {
  seasonId: Scalars["String"]["input"];
  urlKey: Scalars["String"]["input"];
};

export type QueryTeamsArgs = {
  filter?: InputMaybe<QueryTeamInput>;
};

export type QueryUserArgs = {
  id: Scalars["String"]["input"];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<QueryUserInput>;
};

export type QueryVanity_UrlArgs = {
  id: Scalars["String"]["input"];
};

export type QueryVanity_Url_ResolveArgs = {
  domain: Scalars["String"]["input"];
};

export type QueryVanity_UrlsArgs = {
  filter?: InputMaybe<QueryVanityUrlInput>;
};

export type QueryWaiverArgs = {
  id: Scalars["String"]["input"];
};

export type QueryWaiver_SignatureArgs = {
  id: Scalars["String"]["input"];
};

export type QueryWaiver_SignaturesArgs = {
  filter?: InputMaybe<QueryWaiverSignatureInput>;
};

export type QueryWaiversArgs = {
  filter?: InputMaybe<QueryWaiverInput>;
};

export type QueryAgeGroupInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  season?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAnnouncementInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryAttendanceInput = {
  created?: InputMaybe<DateQueryFilter>;
  game?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  roster?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCarouselInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryDivisionInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryEmailLogInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  messageId?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  rosterId?: InputMaybe<StringQueryFilter>;
};

export type QueryFacilityInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  team?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFileMetaInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryGameDateTimeInput = {
  created?: InputMaybe<DateQueryFilter>;
  date?: InputMaybe<StringQueryFilter>;
  datetime?: InputMaybe<DateQueryFilter>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  taken?: InputMaybe<BooleanQueryFilter>;
  time?: InputMaybe<StringQueryFilter>;
};

export type QueryGameInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  away_team?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<DateQueryFilter>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  home_team?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<StringQueryFilter>;
  isTournamentMatch?: InputMaybe<BooleanQueryFilter>;
  losing_team?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  winning_team?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLeagueInput = {
  acronym?: InputMaybe<StringQueryFilter>;
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  name?: InputMaybe<StringQueryFilter>;
  urlKey?: InputMaybe<StringQueryFilter>;
};

export type QueryLeagueRoleInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLeagueWaiverInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRegistrationInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<DateQueryFilter>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  standings?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRoleInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  name?: InputMaybe<StringQueryFilter>;
};

export type QueryRoleMappingInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRosterEntryInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  waiver?: InputMaybe<BooleanQueryFilter>;
};

export type QuerySeasonInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  name?: InputMaybe<StringQueryFilter>;
};

export type QuerySiteSettingInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  season?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySnsMessageInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QuerySponsorInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryTeamInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  manager?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  urlKey?: InputMaybe<StringQueryFilter>;
};

export type QueryTeamLevelInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryTeamPositionInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUserInput = {
  created?: InputMaybe<DateQueryFilter>;
  email?: InputMaybe<StringQueryFilter>;
  firstName?: InputMaybe<StringQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  lastName?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryVanityUrlInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<DateQueryFilter>;
  team?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryWaiverInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
};

export type QueryWaiverSignatureInput = {
  created?: InputMaybe<DateQueryFilter>;
  id?: InputMaybe<StringQueryFilter>;
  modified?: InputMaybe<DateQueryFilter>;
  user?: InputMaybe<Scalars["String"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type Registration = {
  __typename?: "Registration";
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  age_group?: Maybe<AgeGroup>;
  away_games?: Maybe<Array<Game>>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  division?: Maybe<Division>;
  /** The preferred division preference */
  divisionPreference?: Maybe<Scalars["String"]["output"]>;
  /** Elite justification */
  eliteJustification?: Maybe<Scalars["String"]["output"]>;
  home_dates?: Maybe<Array<GameDateTime>>;
  home_games?: Maybe<Array<Game>>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** League last year response */
  leagueLastYear?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  rosters?: Maybe<Array<RosterEntry>>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  season: Season;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  standings?: Maybe<Standings>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team?: Maybe<Team>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team_level?: Maybe<TeamLevel>;
  /** Whether the waiver is signed */
  waiver?: Maybe<Scalars["Boolean"]["output"]>;
  /** The date the waiver was signed */
  waiver_date?: Maybe<Scalars["DateTime"]["output"]>;
};

export type RegistrationAway_GamesArgs = {
  filter?: InputMaybe<QueryGameInput>;
};

export type RegistrationHome_DatesArgs = {
  filter?: InputMaybe<QueryGameDateTimeInput>;
};

export type RegistrationHome_GamesArgs = {
  filter?: InputMaybe<QueryGameInput>;
};

export type RegistrationRostersArgs = {
  filter?: InputMaybe<QueryRosterEntryInput>;
};

/** Primary League Object */
export type Role = {
  __typename?: "Role";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  role_mapping?: Maybe<Array<RoleMapping>>;
};

/** Primary League Object */
export type RoleRole_MappingArgs = {
  filter?: InputMaybe<QueryRoleMappingInput>;
};

/** Primary League Object */
export type RoleMapping = {
  __typename?: "RoleMapping";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  principalId: Scalars["String"]["output"];
  principalType?: Maybe<Scalars["String"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  role?: Maybe<Role>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  user?: Maybe<User>;
};

/** A rostered player on a team */
export type RosterEntry = {
  __typename?: "RosterEntry";
  /** Is this player an all star nominee */
  allstarNomination?: Maybe<Scalars["Boolean"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Emergency contact information for the player */
  emergencyContact?: Maybe<EmergencyContact>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  membershipId?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** The player number */
  number?: Maybe<Scalars["Float"]["output"]>;
  offSeasonPlayer?: Maybe<Scalars["String"]["output"]>;
  player?: Maybe<Player>;
  /** The player position */
  position?: Maybe<Scalars["String"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  registration?: Maybe<Registration>;
  /** Whether this roster spot waiver has been signed */
  waiver?: Maybe<Scalars["Boolean"]["output"]>;
  /** The date this waiver was signed */
  waiverdate?: Maybe<Scalars["DateTime"]["output"]>;
  /** The waiver signer */
  waiversignature?: Maybe<Scalars["String"]["output"]>;
  yearsOfExperience?: Maybe<Scalars["Float"]["output"]>;
};

export type Season = {
  __typename?: "Season";
  age_groups?: Maybe<Array<AgeGroup>>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** League Acronym */
  end?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league: League;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** League Name */
  name: Scalars["String"]["output"];
  /** The date where the registration closes */
  registrationClose?: Maybe<Scalars["DateTime"]["output"]>;
  /** The date where the registration opens */
  registrationOpen?: Maybe<Scalars["DateTime"]["output"]>;
  registrations?: Maybe<Array<Registration>>;
  settings?: Maybe<Array<SiteSetting>>;
  /** League Description */
  start?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SeasonAge_GroupsArgs = {
  filter?: InputMaybe<QueryAgeGroupInput>;
};

export type SeasonRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type SeasonSettingsArgs = {
  filter?: InputMaybe<QuerySiteSettingInput>;
};

export type SiteSetting = {
  __typename?: "SiteSetting";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** The property key */
  key: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league: League;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** The base module grouping of the setting */
  module: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  season?: Maybe<Season>;
  /** The property value */
  value: Scalars["String"]["output"];
};

export type SnsMessage = {
  __typename?: "SnsMessage";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  message?: Maybe<Scalars["JSON"]["output"]>;
  message_id?: Maybe<Scalars["String"]["output"]>;
  message_type?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  subscription_arn?: Maybe<Scalars["String"]["output"]>;
  topic_arn?: Maybe<Scalars["String"]["output"]>;
};

export type Sponsor = {
  __typename?: "Sponsor";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  image?: Maybe<FileMeta>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Main operational object that represents the current state standings */
export type Standings = {
  __typename?: "Standings";
  away_games_played?: Maybe<Scalars["Float"]["output"]>;
  away_losses?: Maybe<Scalars["Float"]["output"]>;
  away_wins?: Maybe<Scalars["Float"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  games_back?: Maybe<Scalars["Float"]["output"]>;
  games_played?: Maybe<Scalars["Float"]["output"]>;
  head_to_head?: Maybe<Scalars["Float"]["output"]>;
  head_to_head_two_only?: Maybe<Scalars["Float"]["output"]>;
  home_games_played?: Maybe<Scalars["Float"]["output"]>;
  home_losses?: Maybe<Scalars["Float"]["output"]>;
  home_wins?: Maybe<Scalars["Float"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  losses?: Maybe<Scalars["Float"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  opponents_opponents_winning_percent?: Maybe<Scalars["Float"]["output"]>;
  opponents_winning_percent?: Maybe<Scalars["Float"]["output"]>;
  points?: Maybe<Scalars["Float"]["output"]>;
  points_allowed?: Maybe<Scalars["Float"]["output"]>;
  points_allowed_average?: Maybe<Scalars["Float"]["output"]>;
  points_for?: Maybe<Scalars["Float"]["output"]>;
  points_for_average?: Maybe<Scalars["Float"]["output"]>;
  power_ranking?: Maybe<Scalars["Float"]["output"]>;
  ratings_percentage_index?: Maybe<Scalars["Float"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  registration?: Maybe<Registration>;
  ties?: Maybe<Scalars["Float"]["output"]>;
  weighted_winning_percent?: Maybe<Scalars["Float"]["output"]>;
  win_loss_percent?: Maybe<Scalars["Float"]["output"]>;
  wins?: Maybe<Scalars["Float"]["output"]>;
};

export type StringQueryFilter = {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  ne?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<Scalars["String"]["input"]>;
  regex?: InputMaybe<Scalars["String"]["input"]>;
};

export type Team = {
  __typename?: "Team";
  /** @deprecated deprecated */
  color?: Maybe<Scalars["String"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated deprecated */
  description?: Maybe<Scalars["String"]["output"]>;
  facilities?: Maybe<Array<Facility>>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  logo?: Maybe<FileMeta>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  manager?: Maybe<User>;
  /** @deprecated deprecated */
  membershipExpiration?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated deprecated */
  membershipLevel?: Maybe<Scalars["String"]["output"]>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Team Level Name */
  name?: Maybe<Scalars["String"]["output"]>;
  positions?: Maybe<Array<TeamPosition>>;
  registrations?: Maybe<Array<Registration>>;
  /** @deprecated deprecated */
  urlKey?: Maybe<Scalars["String"]["output"]>;
};

export type TeamFacilitiesArgs = {
  filter?: InputMaybe<QueryFacilityInput>;
};

export type TeamPositionsArgs = {
  filter?: InputMaybe<QueryTeamPositionInput>;
};

export type TeamRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

export type TeamLevel = {
  __typename?: "TeamLevel";
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  age_group: AgeGroup;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  divisions?: Maybe<Array<Division>>;
  games?: Maybe<Array<Game>>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Team Level Name */
  name: Scalars["String"]["output"];
  registrations?: Maybe<Array<Registration>>;
  /** sort order for a list of levels */
  sortOrder?: Maybe<Scalars["Float"]["output"]>;
};

export type TeamLevelDivisionsArgs = {
  filter?: InputMaybe<QueryDivisionInput>;
};

export type TeamLevelGamesArgs = {
  filter?: InputMaybe<QueryGameInput>;
};

export type TeamLevelRegistrationsArgs = {
  filter?: InputMaybe<QueryRegistrationInput>;
};

/** Primary League Object */
export type TeamPosition = {
  __typename?: "TeamPosition";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  positionType?: Maybe<Scalars["String"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team?: Maybe<Team>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  user?: Maybe<User>;
};

export type UpdateAgeGroupInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** whether invitation scheduling is enabled for this age group */
  inviteSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Determines if rosters are locked for this age group */
  lockRoster?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Age group name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether open scheduling is enabled for this age group */
  openSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SKU for determining the related purchasable product */
  registrationProduct?: InputMaybe<Scalars["String"]["input"]>;
  /** Controls whether scheduling is open for this age group */
  schedulingOpen?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateAnnouncementInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** The body of the message */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The body of the message */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  /** The title of the announcement */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAttendanceInput = {
  /** Whether the player attended the game */
  attended?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  game?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Whether the player plans to attend the game */
  planning_to_attend?: InputMaybe<Scalars["Boolean"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  roster?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateCarouselInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  linktext?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateDivisionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateEmailLogInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  messageId?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  response?: InputMaybe<Scalars["JSON"]["input"]>;
  responseCode?: InputMaybe<Scalars["String"]["input"]>;
  rosterId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFacilityInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  fieldDescription?: InputMaybe<Scalars["String"]["input"]>;
  fieldName?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFileMetaInput = {
  container?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateGameDateTimeInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  datetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  taken?: InputMaybe<Scalars["Boolean"]["input"]>;
  time?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateGameInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator if the away team forfeited */
  awayTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * A value used to inform the home team that the away team has offered
   * to use their facility to host the game
   */
  awayTeamOffersToHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the away team */
  awayTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  away_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator to show the date is confirmed */
  confirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the confirmation happened */
  confirmedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** Property to explicity exclude a match from standing calculations. */
  excludeFromStandings?: InputMaybe<Scalars["Boolean"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of match */
  gameType?: InputMaybe<Scalars["String"]["input"]>;
  /** If this game appears in a sequence, the order number in that sequence */
  game_number?: InputMaybe<Scalars["Float"]["input"]>;
  /** Indicator if the home team forfeited */
  homeTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the home team */
  homeTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  home_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has an outcome */
  isPlayed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  isTied?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Should not be used */
  isTournamentMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  losing_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  losing_team_id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Tracker to see if an official was assigned */
  officialAssigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A message to indicate why the game is postponed */
  postponeReason?: InputMaybe<Scalars["String"]["input"]>;
  /** A flag to indicate tha game is postponed */
  postponed?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  winning_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  winning_team_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateLeagueInput = {
  /** League Acronym */
  acronym?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for age group directors */
  adgRole?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for admins */
  adminRole?: InputMaybe<Scalars["String"]["input"]>;
  /** A tagline to display for a league */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /** League Primary Color */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** A list of domains */
  domains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Url for this league */
  leagueUrl?: InputMaybe<Scalars["String"]["input"]>;
  leaguesettings?: InputMaybe<LeagueSettingInput>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** A legacy value for determining which league is by a url part */
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateLeagueRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateLeagueWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateRegistrationInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** The preferred division preference */
  divisionPreference?: InputMaybe<Scalars["String"]["input"]>;
  /** Elite justification */
  eliteJustification?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** League last year response */
  leagueLastYear?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  standings?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the waiver is signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the waiver was signed */
  waiver_date?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type UpdateRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateRoleMappingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  principalId?: InputMaybe<Scalars["String"]["input"]>;
  principalType?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateRosterEntryInput = {
  /** Is this player an all star nominee */
  allstarNomination?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Emergency contact information for the player */
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  membershipId?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The player number */
  number?: InputMaybe<Scalars["Float"]["input"]>;
  offSeasonPlayer?: InputMaybe<Scalars["String"]["input"]>;
  player?: InputMaybe<PlayerInput>;
  /** The player position */
  position?: InputMaybe<Scalars["String"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this roster spot waiver has been signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date this waiver was signed */
  waiverdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The waiver signer */
  waiversignature?: InputMaybe<Scalars["String"]["input"]>;
  yearsOfExperience?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateSeasonInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Acronym */
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The date where the registration closes */
  registrationClose?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The date where the registration opens */
  registrationOpen?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type UpdateSiteSettingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The property key */
  key?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The base module grouping of the setting */
  module?: InputMaybe<Scalars["String"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** The property value */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSnsMessageInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  message_type?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  subscription_arn?: InputMaybe<Scalars["String"]["input"]>;
  topic_arn?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSponsorInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateStandingsInput = {
  away_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  away_losses?: InputMaybe<Scalars["Float"]["input"]>;
  away_wins?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  games_back?: InputMaybe<Scalars["Float"]["input"]>;
  games_played?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head_two_only?: InputMaybe<Scalars["Float"]["input"]>;
  home_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  home_losses?: InputMaybe<Scalars["Float"]["input"]>;
  home_wins?: InputMaybe<Scalars["Float"]["input"]>;
  losses?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  opponents_opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  points?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed_average?: InputMaybe<Scalars["Float"]["input"]>;
  points_for?: InputMaybe<Scalars["Float"]["input"]>;
  points_for_average?: InputMaybe<Scalars["Float"]["input"]>;
  power_ranking?: InputMaybe<Scalars["Float"]["input"]>;
  ratings_percentage_index?: InputMaybe<Scalars["Float"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  ties?: InputMaybe<Scalars["Float"]["input"]>;
  weighted_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  win_loss_percent?: InputMaybe<Scalars["Float"]["input"]>;
  wins?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  manager?: InputMaybe<Scalars["String"]["input"]>;
  membershipExpiration?: InputMaybe<Scalars["DateTime"]["input"]>;
  membershipLevel?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTeamLevelInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateTeamPositionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  positionType?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserInput = {
  birthdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  birthdateValidated?: InputMaybe<Scalars["Boolean"]["input"]>;
  cellPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  homePhone?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  stripeId?: InputMaybe<Scalars["String"]["input"]>;
  userPhotoId?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateVanityUrlInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<VanityUrlTypeInput>;
};

export type UpdateWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateWaiverSignatureInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  signature_date?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertAgeGroupInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** whether invitation scheduling is enabled for this age group */
  inviteSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Determines if rosters are locked for this age group */
  lockRoster?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Age group name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether open scheduling is enabled for this age group */
  openSchedulingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SKU for determining the related purchasable product */
  registrationProduct?: InputMaybe<Scalars["String"]["input"]>;
  /** Controls whether scheduling is open for this age group */
  schedulingOpen?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpsertAnnouncementInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** The body of the message */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The body of the message */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  /** The title of the announcement */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertAttendanceInput = {
  /** Whether the player attended the game */
  attended?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  game?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Whether the player plans to attend the game */
  planning_to_attend?: InputMaybe<Scalars["Boolean"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  roster?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertCarouselInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  linktext?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertDivisionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertEmailLogInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  messageId?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  response?: InputMaybe<Scalars["JSON"]["input"]>;
  responseCode?: InputMaybe<Scalars["String"]["input"]>;
  rosterId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertFacilityInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  fieldDescription?: InputMaybe<Scalars["String"]["input"]>;
  fieldName?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertFileMetaInput = {
  container?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertGameDateTimeInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  datetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  taken?: InputMaybe<Scalars["Boolean"]["input"]>;
  time?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertGameInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator if the away team forfeited */
  awayTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * A value used to inform the home team that the away team has offered
   * to use their facility to host the game
   */
  awayTeamOffersToHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the away team */
  awayTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  away_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicator to show the date is confirmed */
  confirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the confirmation happened */
  confirmedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** Property to explicity exclude a match from standing calculations. */
  excludeFromStandings?: InputMaybe<Scalars["Boolean"]["input"]>;
  facility?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of match */
  gameType?: InputMaybe<Scalars["String"]["input"]>;
  /** If this game appears in a sequence, the order number in that sequence */
  game_number?: InputMaybe<Scalars["Float"]["input"]>;
  /** Indicator if the home team forfeited */
  homeTeamForfeit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Score for the home team */
  homeTeamScore?: InputMaybe<Scalars["Float"]["input"]>;
  home_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has an outcome */
  isPlayed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  isTied?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Should not be used */
  isTournamentMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  losing_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  losing_team_id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Tracker to see if an official was assigned */
  officialAssigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A message to indicate why the game is postponed */
  postponeReason?: InputMaybe<Scalars["String"]["input"]>;
  /** A flag to indicate tha game is postponed */
  postponed?: InputMaybe<Scalars["Boolean"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  winning_team?: InputMaybe<Scalars["String"]["input"]>;
  /** Virtual field to determine if the game has a tied outcome */
  winning_team_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertLeagueInput = {
  /** League Acronym */
  acronym?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for age group directors */
  adgRole?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for admins */
  adminRole?: InputMaybe<Scalars["String"]["input"]>;
  /** A tagline to display for a league */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /** League Primary Color */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** A list of domains */
  domains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Url for this league */
  leagueUrl?: InputMaybe<Scalars["String"]["input"]>;
  leaguesettings?: InputMaybe<LeagueSettingInput>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** A legacy value for determining which league is by a url part */
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertLeagueRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertLeagueWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertRegistrationInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  division?: InputMaybe<Scalars["String"]["input"]>;
  /** The preferred division preference */
  divisionPreference?: InputMaybe<Scalars["String"]["input"]>;
  /** Elite justification */
  eliteJustification?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** League last year response */
  leagueLastYear?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  standings?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_level?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the waiver is signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date the waiver was signed */
  waiver_date?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type UpsertRoleInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertRoleMappingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  principalId?: InputMaybe<Scalars["String"]["input"]>;
  principalType?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertRosterEntryInput = {
  /** Is this player an all star nominee */
  allstarNomination?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Emergency contact information for the player */
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  membershipId?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The player number */
  number?: InputMaybe<Scalars["Float"]["input"]>;
  offSeasonPlayer?: InputMaybe<Scalars["String"]["input"]>;
  player?: InputMaybe<PlayerInput>;
  /** The player position */
  position?: InputMaybe<Scalars["String"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this roster spot waiver has been signed */
  waiver?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The date this waiver was signed */
  waiverdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The waiver signer */
  waiversignature?: InputMaybe<Scalars["String"]["input"]>;
  yearsOfExperience?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpsertSeasonInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Acronym */
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The date where the registration closes */
  registrationClose?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The date where the registration opens */
  registrationOpen?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** League Description */
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type UpsertSiteSettingInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** The property key */
  key?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The base module grouping of the setting */
  module?: InputMaybe<Scalars["String"]["input"]>;
  season?: InputMaybe<Scalars["String"]["input"]>;
  /** The property value */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertSnsMessageInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["JSON"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  message_type?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  subscription_arn?: InputMaybe<Scalars["String"]["input"]>;
  topic_arn?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertSponsorInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertStandingsInput = {
  away_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  away_losses?: InputMaybe<Scalars["Float"]["input"]>;
  away_wins?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  games_back?: InputMaybe<Scalars["Float"]["input"]>;
  games_played?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head?: InputMaybe<Scalars["Float"]["input"]>;
  head_to_head_two_only?: InputMaybe<Scalars["Float"]["input"]>;
  home_games_played?: InputMaybe<Scalars["Float"]["input"]>;
  home_losses?: InputMaybe<Scalars["Float"]["input"]>;
  home_wins?: InputMaybe<Scalars["Float"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  losses?: InputMaybe<Scalars["Float"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  opponents_opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  opponents_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  points?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed?: InputMaybe<Scalars["Float"]["input"]>;
  points_allowed_average?: InputMaybe<Scalars["Float"]["input"]>;
  points_for?: InputMaybe<Scalars["Float"]["input"]>;
  points_for_average?: InputMaybe<Scalars["Float"]["input"]>;
  power_ranking?: InputMaybe<Scalars["Float"]["input"]>;
  ratings_percentage_index?: InputMaybe<Scalars["Float"]["input"]>;
  registration?: InputMaybe<Scalars["String"]["input"]>;
  ties?: InputMaybe<Scalars["Float"]["input"]>;
  weighted_winning_percent?: InputMaybe<Scalars["Float"]["input"]>;
  win_loss_percent?: InputMaybe<Scalars["Float"]["input"]>;
  wins?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpsertTeamInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  manager?: InputMaybe<Scalars["String"]["input"]>;
  membershipExpiration?: InputMaybe<Scalars["DateTime"]["input"]>;
  membershipLevel?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  urlKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertTeamLevelInput = {
  age_group?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Team Level Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** sort order for a list of levels */
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpsertTeamPositionInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  positionType?: InputMaybe<Scalars["String"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertUserInput = {
  birthdate?: InputMaybe<Scalars["DateTime"]["input"]>;
  birthdateValidated?: InputMaybe<Scalars["Boolean"]["input"]>;
  cellPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  homePhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<AddressInput>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  stripeId?: InputMaybe<Scalars["String"]["input"]>;
  userPhotoId?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertVanityUrlInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<VanityUrlTypeInput>;
};

export type UpsertWaiverInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertWaiverSignatureInput = {
  /** Standard created timestamp */
  created?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Primary document identifier */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Standard modified timestamp */
  modified?: InputMaybe<Scalars["DateTime"]["input"]>;
  signature_date?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
  waiver?: InputMaybe<Scalars["String"]["input"]>;
};

export type User = {
  __typename?: "User";
  birthdate?: Maybe<Scalars["DateTime"]["output"]>;
  birthdateValidated?: Maybe<Scalars["Boolean"]["output"]>;
  cellPhone?: Maybe<Scalars["String"]["output"]>;
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  email: Scalars["String"]["output"];
  emailVerified?: Maybe<Scalars["Boolean"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  homePhone?: Maybe<Scalars["String"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  league_roles?: Maybe<Array<LeagueRole>>;
  location?: Maybe<Address>;
  managed_teams?: Maybe<Array<Team>>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  positions?: Maybe<Array<TeamPosition>>;
  role_mappings?: Maybe<Array<RoleMapping>>;
  stripeId?: Maybe<Scalars["String"]["output"]>;
  userPhotoId?: Maybe<Scalars["String"]["output"]>;
  username: Scalars["String"]["output"];
  waiver_signatures?: Maybe<Array<WaiverSignature>>;
};

export type UserLeague_RolesArgs = {
  filter?: InputMaybe<QueryLeagueRoleInput>;
};

export type UserManaged_TeamsArgs = {
  filter?: InputMaybe<QueryTeamInput>;
};

export type UserPositionsArgs = {
  filter?: InputMaybe<QueryTeamPositionInput>;
};

export type UserRole_MappingsArgs = {
  filter?: InputMaybe<QueryRoleMappingInput>;
};

export type UserWaiver_SignaturesArgs = {
  filter?: InputMaybe<QueryWaiverSignatureInput>;
};

/** Primary League Object */
export type VanityUrl = {
  __typename?: "VanityUrl";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  domain: Scalars["String"]["output"];
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  league?: Maybe<League>;
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  team?: Maybe<Team>;
  type: VanityUrlType;
};

export type VanityUrlType = {
  __typename?: "VanityUrlType";
  id: Scalars["Float"]["output"];
  type: Scalars["String"]["output"];
};

export type VanityUrlTypeInput = {
  id: Scalars["Float"]["input"];
  type: Scalars["String"]["input"];
};

/** Primary League Object */
export type Waiver = {
  __typename?: "Waiver";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  required?: Maybe<Scalars["Boolean"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
};

/** Primary League Object */
export type WaiverSignature = {
  __typename?: "WaiverSignature";
  /** Standard created timestamp */
  created?: Maybe<Scalars["DateTime"]["output"]>;
  /** Primary document identifier */
  id: Scalars["String"]["output"];
  /** Standard modified timestamp */
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  signature_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  user?: Maybe<User>;
  /** Resolver for a one to many relationship.  This utilizes a data loader to minimize */
  waiver?: Maybe<Waiver>;
};

export type UpsertAttendanceToGameMutationVariables = Exact<{
  attendance: UpsertAttendanceInput;
  gameId: Scalars["String"]["input"];
}>;

export type UpsertAttendanceToGameMutation = {
  __typename?: "Mutation";
  upsert_attendance_to_game: {
    __typename?: "Attendance";
    id: string;
    attended?: boolean | null;
    created?: any | null;
    modified?: any | null;
    planning_to_attend?: boolean | null;
    roster: { __typename?: "RosterEntry"; id: string };
  };
};

export type GetRosterForRegistrationQueryVariables = Exact<{
  teamRegistrationId: Scalars["String"]["input"];
}>;

export type GetRosterForRegistrationQuery = {
  __typename?: "Query";
  registration: {
    __typename?: "Registration";
    id: string;
    rosters?: Array<{
      __typename?: "RosterEntry";
      id: string;
      player?: {
        __typename?: "Player";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  };
};

export type GetAttendanceForGameQueryVariables = Exact<{
  gameId: Scalars["String"]["input"];
}>;

export type GetAttendanceForGameQuery = {
  __typename?: "Query";
  game: {
    __typename?: "Game";
    id: string;
    attendance_records?: Array<{
      __typename?: "Attendance";
      id: string;
      attended?: boolean | null;
      roster: { __typename?: "RosterEntry"; id: string };
    }> | null;
  };
};

export type UpsertGameMutationVariables = Exact<{
  upsert: UpsertGameInput;
  id: Scalars["String"]["input"];
}>;

export type UpsertGameMutation = {
  __typename?: "Mutation";
  upsert_game_to_registration: { __typename?: "Game"; id: string };
};

export type LeagueSettingsQueryVariables = Exact<{
  leagueId: Scalars["String"]["input"];
}>;

export type LeagueSettingsQuery = {
  __typename?: "Query";
  site_settings: Array<{
    __typename: "SiteSetting";
    id: string;
    module: string;
    key: string;
    value: string;
  }>;
};

export const UpsertAttendanceToGameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertAttendanceToGame" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attendance" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpsertAttendanceInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gameId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsert_attendance_to_game" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "attendance" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attendance" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "gameId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "attended" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "modified" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "planning_to_attend" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roster" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertAttendanceToGameMutation,
  UpsertAttendanceToGameMutationVariables
>;
export const GetRosterForRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRosterForRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teamRegistrationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teamRegistrationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rosters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "player" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRosterForRegistrationQuery,
  GetRosterForRegistrationQueryVariables
>;
export const GetAttendanceForGameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAttendanceForGame" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gameId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "game" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "gameId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendance_records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roster" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAttendanceForGameQuery,
  GetAttendanceForGameQueryVariables
>;
export const UpsertGameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertGame" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "upsert" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpsertGameInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsert_game_to_registration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "game" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "upsert" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertGameMutation, UpsertGameMutationVariables>;
export const LeagueSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LeagueSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "leagueId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site_settings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "league" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "leagueId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "module" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeagueSettingsQuery, LeagueSettingsQueryVariables>;
